import { reduxForm } from 'redux-form';

import TargetCredentialForm from './TargetCredentialForm';

export default reduxForm({ form: 'targetCredentialForm' })(TargetCredentialForm as any) as any;
